export { default as TiposMateriaPrimaListar } from './Listar';
export { default as TipoMateriaPrimaCrear } from './Crear';
